<!-- Shows the certificates avaiable to a given product. Meaning you should be able to view all the certificates issued to you under a given product(crop)-->
<template>
	<div id="loginBox" class="flex justify-center">
		<div class="w-full max-w-xs self-center">

			<p class="text-center text-grey text-xs">
				<img id="headerImg" src="https://i.imgur.com/xvzcxlU.png" style="margin:16px" />
			</p>


			<form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
				<div class="mb-4">
					<label class="block text-black text-sm mb-2" for="username">
						Username
					</label>
					<input
						class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
						id="username"
						v-model="username"
						type="text"
						placeholder="Username"
					/>
				</div>
				<div class="mb-6">
					<label class="block text-black text-sm mb-2" for="password">
						Password
					</label>
					<input
						class="shadow appearance-none border w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline"
						id="password"
						type="password"
						placeholder="******************"
						v-model="password"
					/>
				</div>
				<div class="flex items-center justify-center">
					<button @click="onSubmitLogin" class="" type="submit">
						Sign In
					</button>
					<!--
<a class="inline-block align-baseline text-sm text-blue-light hover:text-blue-darker" href="#">
Forgot Password?
</a>
					-->
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";

export default {
	name: "LoginView",
	created() {},
data() {
		return {
			password: "",
			username: ""
		};
	},
	methods: {
		userIsAlreadyLoggedIn() {},
		onSubmitLogin(/*e fukin-es-lint lol*/) {
			//            e.preventDefault();
			//validate the data
			var URL = this.$store.state.urls.USER_LOGIN;

			this.username = this.username.replace(/ /g, "");
			asyncRequest.ServerAPI({
				method: "POST",
				api: URL,
				onSuccessCallback: dataIn => {
					this.onLoginSuccess(dataIn);
				},
			onFailCallback: function() {},
				postData: { password: this.password, username: this.username },
				flags: asyncRequest.M_FAIL,
				beforeAfterCallback: false
			});
		},
		determineHomepage() {
			console.log(this.$store.state.userDetails.Permissions.length)
			for (var i = 0; i < this.$store.state.userDetails.Permissions.length; i++) {
				if(this.$store.state.userDetails.Permissions[i].PermissionName == "P_ADD_NEW_CERTIFICATE" ) {
						return "/"
				}

				if(this.$store.state.userDetails.Permissions[i].PermissionName == "P_ADD_NEW_TRANSACTION" ) {
						return "/create-transaction"
				}
			}

			return "/"

		},
		onLoginSuccess(dataIn) {
			this.$store.commit("userDetails/setUserDetails", {
				value: dataIn.Data
			});

			let homePage = this.determineHomepage()

			console.log("homePage", homePage)

			this.$router.push(homePage, "");
		}
	},
	components: {}
};
</script>

<style>
/* We need to do some css to makesure this page is drawn over everything and takes the whole screen space */
#loginBox {
	height: 100%;
	width: 100%;
	background-color: #000;
	position: fixed;
	top: 0;
	z-index: 999;
}
</style>
